import {  use, useEffect, useMemo, type JSX } from "react";
import {  emptyDemande } from "../../types/Demande";
import  { Navigate } from "react-router";
import { useAddDemandeMutation } from "../../stores/OkOkStore";
import { Controller, useForm, useWatch } from "react-hook-form";
import { FloatingInputBootStrap, FloatingPostfixInputBootStrap } from "../Common/FloatingInputBootstrap";
import AttachmentsSelector from "../Common/AttachmentsSelector";
// import { ServiceSelectorBootstrap } from "../Common/ServiceSelector";
// import { PrestaireSelectorBootstrap } from "../Common/PrestataireSelector";
import { UserFondSelectorBootStrap } from "../Fonds/FondSelector";
import AuthContext from "../../contexts/auth/AuthContext";
import DemandeFrais from "./DemandeFrais";
import type { ResponseError } from "../../types/CommonReponse";
import { useTrads } from "../../contexts/trads/useTrads";

function  DemandeAddComponent (): JSX.Element {
     const [addDemande, result] = useAddDemandeMutation();
     const {translate}=useTrads();
    
     const { register,control, setValue,setError,watch ,handleSubmit, formState: { errors }  } = useForm({
         defaultValues:emptyDemande(),
         //shouldUseNativeValidation: true,
         mode:'onBlur',
     });
     const auth=use(AuthContext);
     const fond_id=watch('fond_id');
     const frais=useWatch({control,name:'frais'});
     const year = watch('year');

     useMemo(() => {
          let totalT = 0;
          for(const a in frais){
               totalT+=(frais[a]?frais[a]:0);
          }
          setValue('montant',totalT);
          return totalT;
     }, [frais, setValue]);
    
     useEffect(()=>{
          setValue('frais',{});
     },[fond_id,setValue])

     useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
     return (
          result.isSuccess ? <span><Navigate to={`/demande/`} state={{modified:"true"}}></Navigate></span> :(
          result.error && 'status' in result.error && result.error.status!=400 ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
          result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :

          <form className="row" onSubmit={(event) => void handleSubmit(addDemande)(event)}>

               <div className="col-12  mb-3">
                    <FloatingInputBootStrap
                         name="year"
                         label={translate('demande_annee')}
                         type="number"
                         errors={errors}
                         registerOutput={register("year", {
                              required: translate("demande_error_annee_requis"),
                              min: {
                                   value:(new Date().getFullYear())-1,
                                   message: translate('demande_error_annee_small')
                              },
                              max: {
                                   value:(new Date().getFullYear())+1,
                                   message: translate('demande_error_annee_big')
                              },
                              valueAsNumber: true
                         })}
                    />
               </div>
               <div className="col-12  mb-3">   
                   <UserFondSelectorBootStrap 
                    name="fond_id" 
                    label={translate('demande_fond')} 
                    errors={errors}
                    registerOutput={register("fond_id", {
                              required: translate("demande_error_fond_requis"),
                              valueAsNumber: true
                             
                         })} 
                    year={year}
                    user_id={auth?.user?.id??0}
                    />
               </div>

               {fond_id && fond_id > 0?
               <DemandeFrais 
                    fondId={fond_id} 
                    register={register}
                    errors={errors}
               />
               :null}


               <div className="col-4  mb-3">
                    <FloatingPostfixInputBootStrap
                         name="montant"
                         label={translate('demande_type_frais_total')}
                         prefix="€"
                         type="number"
                         errors={errors}
                         rest={{"step":"0.01","readOnly":true}}
                         registerOutput={register("montant", {
                              required: translate("demande_error_type_frais_total_requis"),
                              min: {
                                   value:0.1,
                                   message: translate('demande_error_type_frais_total_small')
                              },
                              valueAsNumber: true
                         })}
                    />
               </div>
               <div className="col-12  mb-3">
                    <p>{translate('demande_preuves')}</p>
                    <Controller
                         control={control}
                         name="preuves"
                         render={({ field }) => <AttachmentsSelector value={field.value} name={field.name} onBlur={field.onBlur} onChange={field.onChange} disabled={field.disabled} accept="image/png, image/jpeg, application/pdf" />}
                    />
               </div>
               <div className="col-12  mb-3">
                    <p>{translate('demande_justificatifs')}</p>
                    <Controller
                         control={control}
                         name="justificatifs"
                         render={({ field }) => <AttachmentsSelector value={field.value} name={field.name} onBlur={field.onBlur} onChange={field.onChange} disabled={field.disabled} accept="image/png, image/jpeg, application/pdf" />}
                    />
               </div>

               <div className="col-12  mb-3">
                    <button type="submit">{translate('form_submit')}</button>
               </div>
          </form>
        )
     );

}


export default DemandeAddComponent;